/*
* @Author: gujianghua
* @Date:   2018-08-08 11:28:05
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-03-10 10:49:44
*/
import { service } from '@/utils/request'

export default {
	/**
	 * [getDataList 推送列表]
	 * @param  {[obj]} params [筛选信息]
	 * @return {[obj]} 
	 */
	getDataList(params) {
	  return service({
	    url: '/cloud/activity/v1/signmanage/getSignGiftPage',
	    method: 'get',
	    params: params
	  })
	},
	/**
	 * [giftSwitch 上下架]
	 * @param  {[obj]} params [id,状态]
	 * @return {[obj]}
	 */
	giftSwitch(params) {
	  return service({
	    url: '/cloud/activity/v1/signmanage/updateSignGiftState',
	    method: 'post',
	    params: params
	  })		
	},
	/**
	 * [createGift 创建礼品]
	 * @param  {[obj]} data [表单]
	 * @return {[obj]}
	 */
	createGift(data) {
	  return service({
	    url: '/cloud/activity/v1/signmanage/addSignGift',
	    method: 'post',
	    data: data
	  })			
	},
	/**
	 * [removeGift 删除]
	 * @param  {[obj]} params [giftId]
	 * @return {[obj]}
	 */
	removeGift(params) {
	  return service({
	    url: '/cloud/activity/v1/signmanage/deleteSignGift',
	    method: 'post',
	    params: params
	  })			
	},
	/**
	 * [getGiftDetail 获取详情]
	 * @param  {[obj]} params [giftId]
	 * @return {[obj]}
	 */
	getGiftDetail(params) {
	  return service({
	    url: '/cloud/activity/v1/signmanage/getSignGift',
	    method: 'get',
	    params: params
	  })			
	},
	/**
	 * [updateGift 更新签到礼品]
	 * @param  {[obj]} data [更新表单]
	 * @return {[obj]}
	 */
	updateGift(data) {
	  return service({
	    url: '/cloud/activity/v1/signmanage/updateSignGift',
	    method: 'post',
	    data: data
	  })
	},
	getCourseList(params) {
	  return service({
	    url: '/cloud/activity/v1/sign/getCourseList',
	    method: 'get',
	    params: params
	  })			
	},
}


// WEBPACK FOOTER //
// ./src/api/operateManage/signGift.js